"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_BUTTON = exports.DELETE_CONFIRMATION_DIALOG = exports.DELETE_BUTTON = exports.CANCEL_BUTTON = exports.BUTTONS = void 0;
const BUTTONS = exports.BUTTONS = 'rating-and-review-dialog-buttons';
const SUBMIT_BUTTON = exports.SUBMIT_BUTTON = 'submit-review-button';
const CANCEL_BUTTON = exports.CANCEL_BUTTON = 'cancel-review-button';
const DELETE_BUTTON = exports.DELETE_BUTTON = 'delete-review-button';
const DELETE_CONFIRMATION_DIALOG = exports.DELETE_CONFIRMATION_DIALOG = 'delete-confirmation-dialog';
